import React, { useState, useRef } from "react";
import { Tooltip, OverlayTrigger, Row, Col, Button, Table, Form } from "react-bootstrap";
import jsDig from "utils/jsDig.js";

export default function Inflation(props) {
  const section = props.section;
  const csvUploadRef = useRef();
  const lodashClonedeep = require("lodash/cloneDeep");

  const [selectedPlatform, setSelectedPlatform] = useState(props.platforms[0]);
  let yieldMetrics = ["Revenue", "Conversions"];
  const [inflation, setInflation] = useState(props.daily_yields);
  const copyInflation = () => {
    let copyInflationArray = { ...inflation };
    if (selectedPlatform === props.platforms[0]) {
      // using deep copy to avoid the object referencing another object but actually just copying the values
      copyInflationArray[`${selectedPlatform.toLowerCase()}`] = lodashClonedeep(inflation[`${props.platforms[1].toLowerCase()}`]);
    } else if (selectedPlatform === props.platforms[1]) {
      copyInflationArray[`${selectedPlatform.toLowerCase()}`] = lodashClonedeep(inflation[`${props.platforms[0].toLowerCase()}`]);
    }
    setInflation({ ...copyInflationArray });
  };

  const uploadCsv = (e) => {
    let fileInput = $(e.target).get(0);
    let yieldTable = $(`.${props.section}-${selectedPlatform.toLowerCase()}-yield-table`);
    let reader = new FileReader();
    var extension = fileInput.files[0].name.split('.').pop().toLowerCase() // file extension from input file
    var fileTypes = ['csv'];
    var isSuccess = fileTypes.indexOf(extension) > -1;
    if (isSuccess) {
      reader.readAsText(fileInput.files[0]);

      function processCsv(file, yieldTable) {
        let yields = file.replace(/[\r]+/g, "").split("\n");
        let tableColumns = yieldTable.find("tbody tr").first().children().length - 1;
        let currentRow = 0;
        let currentColumn = 0;
        let newInflation = { ...inflation };
        yieldTable.find("input").each(function (index) {
          if (typeof yields[currentRow] == "string") {
            $(this).val(yields[currentRow].split(",")[currentColumn]);
            newInflation[selectedPlatform.toLowerCase()][yieldMetrics[currentColumn].toLowerCase()][currentRow + 1] =
              yields[currentRow].split(",")[currentColumn];
          }
          if ((index + 1) % tableColumns == 0) {
            currentRow++;
            currentColumn = 0;
          } else {
            currentColumn++;
          }
        });
        setInflation(newInflation);
      }

      reader.onload = function () {
        processCsv(reader.result, yieldTable);
      };
    }
  };

  const ComingSoonTooltip = () => {
    const renderTooltip = (refs) => (
      <Tooltip className="grow-tooltip" id="button-tooltip" {...refs}>
        <div className="primary">This feature is coming soon.</div>
      </Tooltip>
    );

    return (
      <div className="d-inline-block block-it-mobile">
        <OverlayTrigger overlay={renderTooltip}>
          <Button style={{ opacity: "0.6", cursor: "default" }} variant="info" className="my-3 mr-3 btn-sm coming-soon">
            Import from linked accounts
          </Button>
        </OverlayTrigger>
      </div>
    );
  };

  return (
    <>
      <div>
        {props.platforms === "Facebook" ? (
          <>
            <Form.Control className="primary" size="md" as="select" style={{ width: "362px", paddingLeft: "20px" }}>
              <option>Facebook</option>
            </Form.Control>
          </>
        ) : (
          <>
            <Form.Control
              as="select"
              style={{ width: "362px" }}
              className="my-2"
              onChange={(e) => {
                setSelectedPlatform(e.target.value);
              }}
              value={selectedPlatform}>
              {props.platforms.map((platform, index) => {
                return <option key={index}>{platform}</option>;
              })}
            </Form.Control>
          </>
        )}

        <input
          style={{ backgroundColor: "#3291C1", display: "none" }}
          className="py-1 m-2"
          type="file"
          accept=".csv"
          ref={csvUploadRef}
          onChange={(e) => {
            uploadCsv(e);
          }}
          onClick={(e) => {
            e.target.value = null;
          }}
        />
        <div className="text-center text-md-left">
          <Button style={{ paddingLeft: "19px", paddingRight: "19px" }} variant="info" className="mb-0 mb-md-3 mt-3 btn-sm mr-3" onClick={() => csvUploadRef.current.click()}>
            Import from CSV...
          </Button>
          {ComingSoonTooltip()}
          {props.platforms !== "Facebook" && (
            <Button variant="info" className="my-0 my-md-3  btn-sm mr-3" onClick={copyInflation}>
              Copy and paste from {selectedPlatform == props.platforms[0] ? props.platforms[1] : props.platforms[0]}
            </Button>
          )}
        </div>

        {props.platforms.map((platform, index) => {
          const visability = platform == selectedPlatform ? "flex" : "none";
          return (
            <Row style={{ display: visability }} key={index}>
              {[0, 1].map((tableIndex) => {
                return (
                  <Col lg xl={4} key={tableIndex}>
                    <div className="table-responsive mt-3 inflation-table">
                      <Table className={`${props.section}-${platform.toLowerCase()}-yield-table`}>
                        <thead>
                          <tr>
                            <th width="20%"></th>
                            {yieldMetrics.map((metric, index) => {
                              return (
                                <th key={index}>
                                  <span className="ml-2 f14 light-primary normal nunito-regular">{metric}</span>
                                </th>
                              );
                            })}
                          </tr>
                        </thead>
                        <tbody>
                          {[...Array(15)].map((blank, index) => {
                            const day = index + 1 + tableIndex * 15;
                            return (
                              <tr key={index}>
                                <td
                                  className="light-primary f16"
                                  style={{
                                    textAlign: "left",
                                    whiteSpace: "nowrap",
                                  }}>
                                  Day {day}
                                </td>

                                {yieldMetrics.map((metric, index) => {
                                  metric = metric.toLowerCase();
                                  const value = jsDig([`${metric}`], inflation[`${platform.toLowerCase()}`])
                                    ? inflation[`${platform.toLowerCase()}`][`${metric}`][day]
                                    : "";

                                  return (
                                    <td key={index}>
                                      <Form.Control
                                        value={day == 30 ? "0" : value}
                                        name={`inflation[${section}][${platform.toLowerCase()}][${metric}][${day}]`}
                                        size="sm"
                                        placeholder=""
                                        onChange={(e) => {
                                          let newInflation = { ...inflation };
                                          if (!newInflation[platform.toLowerCase()]) {
                                            newInflation[platform.toLowerCase()] = {};
                                          }
                                          if (!newInflation[platform.toLowerCase()][metric]) {
                                            newInflation[platform.toLowerCase()][metric] = {};
                                          }
                                          newInflation[platform.toLowerCase()][metric][day] = e.target.value;

                                          setInflation(newInflation);
                                        }}
                                      />
                                    </td>
                                  );
                                })}
                              </tr>
                            );
                          })}
                        </tbody>
                      </Table>
                    </div>
                  </Col>
                );
              })}
            </Row>
          );
        })}
      </div>
    </>
  );
}
